import html2pdf from "html2pdf.js";
import { convertToRFT } from "../../utils/convertToRFT";
import employeeLogo from "../../images/employee.png";

function ThermalPrint({
  billNumber,
  customer,
  items,
  discount,
  discountType,
  date,
  totalAmount = 0,
  Total = 0,
  paid = 0,
  outstandingBalance = 0,
  change = 0,
  formallyOutstandings = 0,
  argSell = "",
  saleType = "",
  fivePercent = "",
  printQuote,
  varTotal,
  paymentMethod = "cash",
  bankName = "",
  cheque = "",
  clearBalance = "",
  currency = "",
  companyNew = "",

}) {
  console.log({
    billNumber,
    customer,
    items,
    discount,
    discountType,
    date,
    totalAmount,
    Total,
    paid,
    outstandingBalance,
    change,
    formallyOutstandings,
    argSell,
    saleType,
    fivePercent,
    printQuote,
    varTotal,
    paymentMethod,
    bankName,
    cheque,
    clearBalance,
    currency,
    companyNew
  });
  

  let temp = localStorage.getItem("template");
  let companyCode = localStorage.getItem("companyCode");
  let baseUrl = localStorage.getItem("base_url");
  // let imgSrc = baseUrl ? baseUrl : employeeLogo;
  let imgSrc = baseUrl;
  let user = localStorage.getItem("username") || localStorage.getItem("token");
  let company = localStorage.getItem("company");
  let address = localStorage.getItem("address");
  let street = localStorage.getItem("street");

  let phone1 = localStorage.getItem("p1");
  let phone2 = localStorage.getItem("p2");
  let phone = localStorage.getItem("phone");
  let terms = localStorage.getItem("terms") || "";
  terms = terms.replace(/^/, "• ").replace(/\. ?/g, "<br/>\n• ");
  console.log("itemsbatchNumber", items);

  console.log(`"ttotal"'${totalAmount}'`, `'${paid}'`);
  const result = (Number(totalAmount) - Number(paid)).toFixed(3);
  console.log("result", result);
  let totalQty = 0;
  let rows = items
    .map((item) => {
      let { saleQty, itemPrice, totalPrice } = convertToRFT(
        saleType,
        item,
        "",
        fivePercent
      );
      const costPriceBatchInside =
        items?.batchNumber?.[0]?.newItem?.costPrice ?? null;
      const salePriceBatchInside =
        items?.batchNumber?.[0]?.newItem?.price ?? null;
      const totalBatch = Number(salePriceBatchInside) * Number(saleQty);

      totalQty += parseInt(saleQty);
      return `
    <tr>
      <td style="font-size: 14px; font-family: 'Arial', sans-serif;font-weight:bold;text-align:left !important">${
        item?.name
      }</td>
      <td style="font-size: 12px; font-family: 'Arial', sans-serif;font-weight:bold">${saleQty}</td>
      <td style="font-size: 12px; font-family: 'Arial', sans-serif;font-weight:bold">${
        item?.unit
      }</td>
      <td style="font-size: 12px;font-family: 'Arial', sans-serif;font-weight:bold">${
        itemPrice || salePriceBatchInside
      }</td>
      <td style="font-size: 12px; font-family: 'Arial', sans-serif;font-weight:bold">${
        totalPrice || totalBatch
      }</td>
    </tr>`;
    })
    .join("");

  let htmlContent = `
  <div style="text-align: center; margin-top:15px; max-width:250px; margin-left:26px;">
 ${
   imgSrc ? `<img src="${imgSrc}" style="width: 100px; height: 100px;" /> ` : ""
 }
 
    ${
      temp === "thermalInvoice"
        ? `<h1>Invoice#</h1>`
        : `
    <h1 style="font-size:15px">${company}</h1>
    <p style="margin:0px;font-size:14px">${street ? street : ""}${
            address ? address : ""
          }</p>
   ${
     companyCode == "2622"
       ? phone && phone1 && phone2
         ? `<p style="margin:0px;font-size:14px">Phone: ${phone ? phone : ""}${
             phone1 ? phone1 : ""
           }${phone2 ? ", " + phone2 : ""}${
             !phone1 && !phone2 ? phone : ""
           }</p>`
         : ""
       :`<p style="margin:0px;font-size:14px">
       Phone: 
       ${phone1 ? phone1 : ""}
       ${phone2 ? "<br>" + phone2 : ""}
       ${!phone1 && !phone2 ? phone : ""}
     </p>`
     
   }
    `
    }
    <p style="margin:0px;font-size:14px"> Customer: ${customer}</p>
          ${
            cheque  
               ?  `<p style="margin:0px;font-size:14px"> Cheque No: ${cheque}</p>`
               : ""
           }

    <p style="margin:0px;font-size:14px">Bill # ${billNumber}, Date: ${date}</p>
           ${
             paymentMethod == "bank"
               ? `  <p style="margin:0px;font-size:14px"><span style="">Bank Name:</span> ${bankName}</p>`
               : ""
           }
    <table style="width: 100%; text-align: center; margin-top: 20px; border-collapse: collapse;">
      <thead>
        <tr style="font-size: 12px; border: 2px solid black;">
          <th style="width: 60%; border: 2px solid black;text-align:left">ITEM</th>
          <th style="width: 15%; border: 2px solid black;">QTY</th>
          <th style="width: 15%; border: 2px solid black;">UNIT</th>
          <th style="width: 15%; border: 2px solid black;">RATE</th>
          <th style="width: 15%; border: 2px solid black;">TOTAL</th>
        </tr>
      </thead>
      <tbody style="border: 2px solid black;">
        ${rows}
      </tbody>
    </table>

    <div style="border:2px solid black;display:flex;flex-direction:column;justify-content:center;align-items:flex-end; margin-top: -2px;">
      <p style="font-size: 12px;margin: 2px 0;margin-right:24px;font-weight:bold;"><span style="font-weight:bold">Net Total:</span> ${Number(
        totalAmount
      ).toFixed(3)}</p>
      <p style="font-size: 12px;margin: 2px 0;margin-right:24px;font-weight:bold;"><span style="font-weight:bold">Discount: </span>${
        discount ? discount : "0"
      } ${
    companyCode == "1916"
      ? "AED"
      : discountType === "percentage"
      ? "%"
      : `${currency}`
  }</p>
      <p style="font-size: 12px;margin: 2px 0;margin-right:24px;font-weight:bold;"><span style="font-weight:bold"></span>PKR ${(
        Number(totalAmount) + Number(formallyOutstandings)
      ).toFixed(3)}</p>
      ${
        companyCode == "1916"
          ? `
        <p style="font-size: 12px; margin: 2px 0; margin-right: 24px; font-weight: bold;">
          <span style="font-weight: bold;">Var Total: </span>AED ${varTotal}
        </p>`
          : ""
      }
    </div>

    <div style="border:2px solid black;display:flex;flex-direction:column;justify-content:center;align-items:flex-end; margin-bottom: 0;">
      <p style="font-size: 12px;margin: 2px 0;margin-right:24px;font-weight:bold"><span style="font-weight:bold">Received:</span> ${paid}</p>
      <p style="font-size: 12px;margin: 2px 0;margin-right:24px;font-weight:bold"><span style="font-weight:bold">Change:</span>  ${
        Number(paid) < Number(totalAmount) ? 0 : Math.abs(change)
      }</p>
    </div>

    <div style="display:flex; margin-top: -12px;">
      <p style="border: 1px solid black;font-size: 12px;font-weight:bold"><span style="font-weight:bold">Bill Balance:</span> ${
        Number(paid) > Number(totalAmount) ? 0 : Math.abs(change)
      }</p>
      <p style="border: 1px solid black;font-size: 12px;font-weight:bold"><span style="font-weight:bold">Old. Bal:</span> ${formallyOutstandings}</p>
      <p style="border: 1px solid black;font-size: 12px;font-weight:bold"><span style="font-weight:bold">New. Bal: </span>${
        paid >= Number(formallyOutstandings) + Number(totalAmount)
          ? 0
          : Number(formallyOutstandings) + Number(paid) < Number(totalAmount)
          ? 0
          : Math.abs(change)
        //  paid >= Number(formallyOutstandings) + Number(totalAmount) ? 0 : ( (Number(paid) > Number(totalAmount) ? 0 :   Number((Number(totalAmount) - Number(paid)).toFixed(3))))
      }</p>
      <p style="border: 1px solid black;font-size: 12px;font-weight:bold"><span style="font-weight:bold">Quantity:</span> ${totalQty}</p>
      <p style="border: 1px solid black;font-size: 12px;font-weight:bold"><span style="font-weight:bold">Payment Method:</span> ${paymentMethod}</p>
    </div>
   

  </div>

  <div  style="display:flex;flex-direction:column;align-items:center;">
  <div style="display:flex;">
      ${
        terms
          ? `<p style="margin-top: 20px;font-size: 12px;">${
              terms.replace(/(^|\.\s*)(?=[A-Za-z])/g, "<br>• ")

              // This handles starting from the first sentence and new sentences after full stops
            }</p>`
          : ""
      }
    
    </div>

     <div style="display: flex;flex-direction:column; align-items: center; justify-content: center;width:20%; gap: 10px;">
  
    <img src="${
      companyNew?.billStamp?.url
    }" style="width: 120%; height:auto;"   crossorigin="anonymous"/>
  </div>

 
  </div>
    

`;

  let opt = {
    margin: 0,
    filename: "receipt.pdf",
    image: { type: "jpeg", quality: 0.2 },
    html2canvas: { scale: 2, useCORS: true },
    jsPDF: { unit: "mm", format: [80, 210], orientation: "portrait" }, // Adjust height based on receipt length
  };


  html2pdf()
    .from(htmlContent)
    .set(opt)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 3000); // Wait a second for the PDF to load before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
}

export default ThermalPrint;
